import { useState } from 'react';
import { Banner } from '@/components/Banner';
import { Button } from '@/components/Button';
import { Card, Seccion } from '@/components/Card';
import { buscarActualizacion, forzarActualizacion, hayConexion } from '@/lib/recovery';

type Estado =
  | { fase: 'inactivo' }
  | { fase: 'buscando' }
  | { fase: 'hayNueva'; mensaje: string }
  | { fase: 'alDia'; mensaje: string }
  | { fase: 'aplicando' };

/**
 * Busqueda manual de version nueva.
 *
 * MOTIVO DE EXISTIR: en iOS la aplicacion instalada queda suspendida en memoria
 * y al reabrirla desde el icono no hace una carga real de la pagina, asi que el
 * aviso automatico de version nueva puede no aparecer aunque exista. Sin este
 * boton, actualizar dependia de que iOS lo decidiera, y la aplicacion se
 * quedaba vieja sin forma de pedirle nada.
 */
export function BuscarActualizacion() {
  const [estado, setEstado] = useState<Estado>({ fase: 'inactivo' });

  async function buscar() {
    setEstado({ fase: 'buscando' });
    const resultado = await buscarActualizacion();
    setEstado(
      resultado.hayNueva
        ? { fase: 'hayNueva', mensaje: resultado.mensaje }
        : { fase: 'alDia', mensaje: resultado.mensaje },
    );
  }

  async function aplicar() {
    setEstado({ fase: 'aplicando' });
    const resultado = await forzarActualizacion();
    if (!resultado.exito) {
      setEstado({ fase: 'alDia', mensaje: resultado.mensaje });
    }
  }

  const ocupado = estado.fase === 'buscando' || estado.fase === 'aplicando';

  return (
    <Seccion
      titulo="Version de la aplicacion"
      descripcion="En iPhone la app instalada no siempre revisa sola si hay algo nuevo."
    >
      <Card>
        <Button variante="secundario" disabled={ocupado} onClick={() => void buscar()}>
          {estado.fase === 'buscando' ? 'Buscando…' : '🔍 Buscar actualizacion'}
        </Button>

        {estado.fase === 'alDia' && (
          <div className="mt-3">
            <Banner tono={hayConexion() ? 'exito' : 'aviso'} titulo={estado.mensaje} />
          </div>
        )}

        {estado.fase === 'hayNueva' && (
          <div className="mt-3 space-y-2">
            <Banner tono="info" titulo={estado.mensaje}>
              Al actualizar se recarga la aplicacion. Tus datos no se tocan.
            </Banner>
            {/* El estado 'aplicando' se muestra en su propio aviso mas abajo. */}
            <Button disabled={ocupado} onClick={() => void aplicar()}>
              Actualizar ahora
            </Button>
          </div>
        )}

        {estado.fase === 'aplicando' && (
          <div className="mt-3">
            <Banner tono="info" titulo="Actualizando…">
              No cierres la aplicacion.
            </Banner>
          </div>
        )}
      </Card>
    </Seccion>
  );
}
